import { CCol, CContainer, CRow } from '@coreui/react-pro'
import React, { useState } from 'react'
import './Messages.scss'
import PageHeader from 'src/components/common/PageHeader/PageHeader'
import MessageList from './MessageList'
import MessageThread from './MessageThread'

const Message = () => {
  const [text, setText] = useState('')

  return (
    <CContainer>
      <div className="messages-header-wrapper">
        <PageHeader />
      </div>
      <CRow className="h-100">
        <CCol className="messagelist-col h-100">
          <MessageList setText={setText} />
        </CCol>
        <CCol className="messagethread-col h-100">
          <MessageThread text={text} setText={setText} />
        </CCol>
      </CRow>
    </CContainer>
  )
}

export default Message
